<template>
  <!-- begin widget-chat -->
  <div v-if="job" class="widget-chat rounded mt-3">
    <ImageModal />
    <!-- begin widget-chat-header -->
    <!-- begin widget-chat-body -->
    <div class="widget-chat-body" data-scrollbar="true" data-height="235px">
      <!--<div class="text-center text-gray-500 m-3 fw-bold">Today</div>-->
      <div class="widget-chat-item with-media" :class="item.user.id == user.id ? 'end' : 'start'"
        v-for="(item, index) in job.messages" :key="index">
        <div class="widget-chat-media">
          <img onerror="javascript:this.src='/images/avatar/user.png'" alt=""
            :src="`/images/avatar/` + item.user.avatar" />
        </div>
        <div class="widget-chat-info">
          <div class="widget-chat-info-container">
            <div class="widget-chat-name text-indigo">{{ item.user.name }}</div>
            <div class="widget-chat-message pre-formatted">
              <div v-html="addTagsToLinks(item.message)"></div>
              <div class="d-flex flex-wrap">
                <div class="m-2" v-for="(image, index) in item.images" :key="index">
                  <!-- BEGIN image -->
                  <img class="imageWrapper" :src="`/images/screen/` + image.name" alt=""
                    @click="open(`/images/screen/` + image.name)" />
                  <!-- END image -->
                </div>
              </div>
            </div>
            <div class="widget-chat-time">{{ item.created_at }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end widget-chat-body -->



    <!-- begin widget-input -->
    <div class="widget-input">
      <form action="" method="POST" name="">
        <div class="d-flex flex-column">
          <div class="pt-2" style="background-color: var(--bs-body-bg);">
            <b-tabs nav-wrapper-class="nav nav-tab" content-class="panel mb-0 p-3 rounded-0">
              <!-- BEGIN tab -->
              <b-tab active @click="tabClick()">
                <template slot="title">
                  <span class="d-sm-none text-primary small">Отчет</span>
                  <span class="d-sm-block d-none text-primary">Отчет</span>
                </template>
                <div>
                  <textarea v-model="message" class="form-control" rows="6"></textarea>
                  <small v-show="!error_message" class="text-gray-500">Ваш отчет</small>
                  <small class="text-danger">{{ error_message }}</small>

                  <ImageBar :images="images" :removeImage="removeImage"></ImageBar>
                  <div class="d-flex justify-content-between">
                    <div class="btn btn-default" @click="chooseFiles()">
                      <i class="fas fa-cloud-arrow-up"></i> Скриншот
                    </div>
                    <div class="btn btn-primary w-120" @click="accept()">
                      <i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
                      <span v-show="!loading"> Отправить </span>
                    </div>
                  </div>
                </div>
              </b-tab>
              <!-- END tab -->
              <b-tab @click="tabClick()">
                <template slot="title">
                  <span class="d-sm-none small">Ответ</span>
                  <span class="d-sm-block d-none">Ответ</span>
                </template>
                <div>
                  <textarea v-model="message" class="form-control" rows="6"></textarea>

                  <small v-show="!error_message" class="text-gray-500">Ваш ответ</small>
                  <small class="text-danger">{{ error_message }}</small>

                  <ImageBar :images="images" :removeImage="removeImage"></ImageBar>
                  <div class="d-flex justify-content-between">
                    <div class="btn btn-default" @click="chooseFiles()">
                      <i class="fas fa-cloud-arrow-up"></i> Скриншот
                    </div>
                    <div class="btn btn-info w-120" @click="reply()">
                      <i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
                      <span v-show="!loading"> Отправить</span>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab @click="tabClick()">
                <template slot="title">
                  <span class="d-sm-none small">Отказ</span>
                  <span class="d-sm-block d-none">Отказаться</span>
                </template>

                <div>
                  <div class="text-center">
                    <p class="small pt-5">
                      Если хотите отказаться от выполнения задания нажмите
                      конпку ниже
                    </p>
                    <div @click="cancel()" class="btn btn-warning mt-3 mb-5">
                      Отказаться
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab @click="tabClick()">
                <template slot="title">
                  <span class="d-sm-none text-red small">Арбитраж</span>
                  <span class="d-sm-block d-none text-red">Арбитраж</span>
                </template>
                <div>
                  <p class="small">
                    Обращение в арбитраж это крайняя мера в решении проблемы с
                    заданием. Пожалуйста, попробуйте разрешить ситуацию с
                    заказчиком самостоятельно, напишите комментарий к заданию.
                    Если у вас появились разногласия в ходе выполнения задания,
                    наши админы помогут вам их разрешить.
                  </p>
                  <textarea v-model="message" class="form-control" rows="6"></textarea>

                  <small v-show="!error_message" class="text-gray-500">Опишите подробно
                    претензию</small>
                  <small class="text-danger">{{ error_message }}</small>
                  <ImageBar :images="images" :removeImage="removeImage"></ImageBar>
                  <div class="d-flex justify-content-between">
                    <div class="btn btn-default" @click="chooseFiles()">
                      <i class="fas fa-cloud-arrow-up"></i> Скриншот
                    </div>
                    <div class="btn btn-danger w-110" @click="arbitrage()">
                      <i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
                      <span v-show="!loading"> Арбитраж</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between">
                    <input @change="pickFile" id="fileUpload" ref="fileInput" type="file" style="display: none" />
                  </div>
                </div>
              </b-tab>

            </b-tabs>
          </div>
        </div>
      </form>
    </div>
    <!-- end widget-input -->
  </div>
  <!-- end widget-chat -->
</template>

<script>
import HTTP from "../http";
import {show_error} from "../message";
import axios from "axios";

export default {
  name: "JobChat",
  props: ["job", "task"],
  data() {
    return {
      loading: false,
      message: "",
      status: "REVIEW",
      previewImage: null,
      images: [],
      files: [],
      user: {},
      error_message: "",
    };
  },

  mounted() {
    console.log("job", this.job);
    this.user = JSON.parse(localStorage.getItem("user"));
  },

  methods: {
    isUrlValid(str) {
      let url;
      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    },
    stringToUrl(str) {
      return this.isUrlValid(str) ? `<a target="_blank" href="${str}">${str}</a>` : str
    },
    addTagsToLinks(str) {
      str = str.replace(/(<([^>]+)>)/ig, '')
      let lines = str.split(/\r?\n/)
      lines = lines.map(x => x.split(' ').reduce((accumulator, currentValue) => accumulator + ' ' + this.stringToUrl(currentValue), ''))

      return lines.reduce((accumulator, currentValue) => accumulator + '\r\n' + this.stringToUrl(currentValue))
    },
    tabClick() {
      this.error_message = '';
    },
    arbitrage() {
      if (!this.message) {
        this.error_message = "Опишите подробно суть претензии";
        return;
      }
      this.jobUpdate("ARBITRAGE");
    },
    cancel() {
      this.message = ".";
      this.jobUpdate("CANCELED");
    },
    reply() {
      if (!this.message) {
        this.error_message = "Напишите ваше сообщение";
        return;
      }
      this.jobUpdate("REVIEW");
    },
    accept() {
      if (!this.message && this.task.img_cnt == 0) {
        this.error_message = "Напишите что было сделано";
        return;
      }
      /*if (this.images.length < this.task.img_cnt ) {
        this.error_message = `В отчете должно быть скриншотов минимум ${this.task.img_cnt
          }, сейчас скриншотов ${this.task.img_cn | 0}  `;
        return;
      }*/
      if (!this.message) {
        this.message = "Выполнено";
      }
      this.jobUpdate("REVIEW");
    },

    open(img) {
      window.eventBus.$emit("image.show", img);
    },
    chooseFiles() {
      //document.getElementById("fileUpload").click();
      this.$router.push('/howtoscreen')
    },
    previewFiles(event) {
      console.log(event.target.files);
    },
    selectImage() {
      this.$refs.fileInput.click();
    },
    pickFile() {
      console.log("pickFile");
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        this.files.push(file[0]);
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
          this.images.push(e.target.result);
        };
        reader.readAsDataURL(file[0]);
      }
    },
    removeImage(index) {
      this.images.splice(index, 1);
    },
    async saveImages(message_id) {
      this.loading = true;
      this.$insProgress.start();
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      };

      for (let i = 0; i < this.files.length; i++) {
        const data = new FormData();
        data.append("avatar", this.files[i]);
        data.append("message_id", message_id);
        await axios
          .post("/api/image", data, config)
          .then((response) => {
            console.log("response", response);
          })
          .catch((error) => {
            show_error(this.$notify, null, error.response.data);
          })
          .finally(() => {
            console.log("finally");
          });
      }
      this.images = [];
      this.files = [];
      this.$insProgress.finish();
    },

    jobUpdate(status) {
      this.error_message = ''
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .put(`/job/${this.job.id}`, {status, message: this.message})
        .then(async (resp) => {
          await this.saveImages(resp.data.id);
          this.message = "";
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data);
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
          window.eventBus.$emit("user.chat.update");
          window.eventBus.$emit("customer.chat.update", this.task.id);
        });
    },
  },
};
</script>

<style>
.imageWrapper {
  width: 150px;
  height: 150px;
  display: block;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}

@media (max-width: 576px) {
  .hide-576 {
    display: none;
  }
}

.w-120 {
  width: 120px !important;
}
</style>
